export default "__VITE_ASSET___Kw9qeiS__"